<div class="notification-page">


    <!-- Clear All -->
    <div class="action-bar" fxLayout="row" fxLayoutAlign="end center" *ngIf="notifications?.length > 0">
        <button class="btn-clear-all" (click)="clearNotifications()">{{'notification.clearAll'|translate}}</button>
    </div>

    <!-- Notification List -->
    <div class="notification-list" *ngIf="notifications?.length > 0">
        <div class="notification-card" *ngFor="let item of notifications" [class.unread]="item.is_read==false">
            <div class="card-top" fxLayout="row" fxLayoutAlign="space-between center">
                <span class="msg-title">{{ getNotificationText(item, 'body') || getNotificationText(item, 'title') || 'Message Text' }}</span>
                <button class="btn-delete" (click)="deleteNotification(item.id)" [matTooltip]="'notification.delete' | translate">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
            <hr class="card-divider">
            <div class="card-bottom" fxLayout="row" fxLayoutAlign="space-between center">
                <span class="msg-date">{{ item?.created_date | date:'dd/MM/yy HH:mm' }}</span>
                <button class="btn-view" *ngIf="item.web_path" (click)="viewClick(item.web_path, item.id)">{{'notification.clickHereToView'|translate}}</button>
                <button class="btn-view" *ngIf="!item.web_path" data-toggle="modal" data-target="#exampleModal"
                    (click)="showNotification(item.id)">{{'notification.readMore'|translate}}</button>
            </div>
        </div>

        <!-- Paginator -->
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" class="paginator-controls">
            <button mat-mini-fab class="btn-page" [disabled]="back_btn=='false'" (click)="preiviouseData()">
                <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <button mat-mini-fab class="btn-page" [disabled]="next_btn=='false'" (click)="nextData()">
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>
    </div>

    <div class="no-data-panel" *ngIf="!notifications || notifications.length == 0">
        <img src="assets/images/no-notification.png" alt="No notifications" class="no-notification-img">
    </div>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="Notification"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ getNotificationText(singleData, 'title') }}</h5>
                    <button matTooltip="back" data-dismiss="modal" type="button" mat-mini-fab><mat-icon
                            aria-hidden="false" aria-label="Example home icon">close</mat-icon></button>
                </div>
                <div class="modal-body">
                    <p>{{ getNotificationText(singleData, 'body') }}</p>
                </div>
            </div>
        </div>
    </div>
</div>